import env from '@/config/env'
import { trackPlatformConnectStarted } from '@/lib/analytics/connectionTracking'

const SCOPE = [
  'instagram_business_basic',
  'instagram_business_content_publish',
  'instagram_business_manage_insights',
] as const

export const AUTH_STATE_STORAGE_KEY = 'ig_auth_state' as const
export type AuthState = { rnd: string; referrerPath: string }

export const startAuthProcess = (opts: Omit<AuthState, 'rnd'>) => {
  const redirectPath = '/auth/instagram'
  const state: AuthState = { ...opts, rnd: Math.random().toString().slice(3, 12) }

  localStorage.setItem(AUTH_STATE_STORAGE_KEY, JSON.stringify(state))

  const url = new URL('https://www.instagram.com/oauth/authorize')
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: env.VITE_INSTAGRAM_CLIENT_ID,
    redirect_uri: `${window.location.origin}${redirectPath}`,
    state: JSON.stringify(state),
    scope: SCOPE.join(','),
    enable_fb_login: '0',
    force_authentication: '1',
  })

  trackPlatformConnectStarted('instagram')
  window.location.href = `${url}?${params}`
}
